
























import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';
import { OverviewLayoutITF, StatusFilter } from '@/interfaces';
import { Getter, Mutation } from 'vuex-class';

@Component
export default class SiteServiceOrdersOverview extends Mixins(OverviewMixin) {
  public statusFilter: StatusFilter = {};
  public version = 1;
  public tableCfg = FieldDefs;

  @Getter('getStatusID')
  public getStatusID!: () => number;

  @Mutation('setStatusID')
  public setStatusID;

  public filterChanged() {
    this.version += 1;
    ((this.$refs.overview as unknown) as OverviewLayoutITF).tableUpdateData();
    // Update store
    this.setStatusID(this.statusFilter.siteserviceorderstatus_id);
  }

  // Lifecycle Functions
  public created() {
    this.statusFilter.siteserviceorderstatus_id = this.getStatusID();
  }
}
